import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import { ReferenciaContenido } from "interfaces/ReferenciaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { ReferenciaPlantillaContenido } from "interfaces/ReferenciaPlantillaContenido";
import MentorsCard from "../../atoms/mentors-card/mentorsCard";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import leftArrow from "../../../assets/images/icons/flecha-izq.png";
import equisCirculo from "../../../../src/assets/images/icons/x.svg";

import "./mentorsIntern.scss";
import "../../molecules/carousel-mentors/carouselMentors.scss"

const MentorsIntern = ({referenciaPlantillaContenido, tituloGeneral, tituloBoton, redireccionBoton} : ReferenciaContenido) => {
    const [filterOptions, setFilterOptions] = useState<Array<string>>([]);
    const [activeOption, setActiveOption] = useState<string>('');
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [optionArray, setOptionArray] = useState<Array<ReferenciaPlantillaContenido>>([]);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [detailCardInfo, setDetailCardInfo] = useState<ReferenciaPlantillaContenido>();
    const getModalInformation = (cardInfo : ReferenciaPlantillaContenido ) : void => {
        setIsOpenModal(true);
        setDetailCardInfo(cardInfo);
    };

    const handleChange = (event) => {
        setActiveOption(event.target.value)
    }

    useEffect(()=>{
        const keysArray : Array<string> = referenciaPlantillaContenido.map((item)=>item.tituloDescripcion);
        const mapKeys : object = {};
        const unicKeys : Array<string> = keysArray.filter((llave) => {
            if (!mapKeys.hasOwnProperty(llave)) {
                mapKeys[llave] = true;
                return true;
            }
            return false;
        });
        setFilterOptions(unicKeys);
        setActiveOption(unicKeys[0]);
    },[])

    useEffect (() => {
        const selectedArray = referenciaPlantillaContenido.filter((cardInfo) => cardInfo.tituloDescripcion === activeOption);
        setOptionArray(selectedArray);
    }, [activeOption])
    
    return (
        <>
            <section className="o-mentors-intern">
                <div className="o-mentors-intern__banner">
                    <Breadcrumb content={ `Inicio / Servicio de Empleo / Personas / Mentoría de Talento / Mentores` } />
                    <Link to={redireccionBoton} className="o-mentors-intern__back-button">
                        <img className="o-mentors-intern__arrow-link" alt="flecha izquierda" src={leftArrow}/>{tituloBoton}
                    </Link>
                    <h1 className="o-mentors-intern__title">{tituloGeneral}</h1>
                </div>
                {window.innerWidth <= 768 ? 
                    <select value={activeOption} onChange={handleChange} className="o-mentors-intern__select">
                        {filterOptions.map((option, index)=>
                            <option value={option} key={`filter-option-${index}`}>{option}</option>
                        )}
                    </select> :
                    <div className="o-mentors-intern__filter">
                        {filterOptions.map((option, index)=>
                            <button 
                                onClick={() => setActiveOption(option)} 
                                key={`filter-option-${index}`} 
                                className={`o-mentors-intern__filter-button ${option === activeOption && 'o-mentors-intern__filter-button--active'}`}
                            >
                                {option}
                            </button>
                        )}
                    </div>
                }
                <div className="o-mentors-intern__card-container">
                    {optionArray.slice(activeIndex * 9 ,(activeIndex * 9) + 9).map((cardInfo) => {
                            return (
                                <MentorsCard
                                    name={cardInfo.tituloBanner}
                                    description={documentToReactComponents(cardInfo.descripcion.json)}
                                    location={cardInfo.tituloDescripcion}
                                    imgUrl={cardInfo.imagenPerfil.file.url}
                                    ctaAction={getModalInformation}
                                    ctaInfo={cardInfo}
                                />
                            );
                    })}
                </div>
                <div className="o-mentors-intern__button-container">
                    <Link className="o-mentors-intern__button" to={redireccionBoton}>
                        <img className="o-mentors-intern__arrow-button" alt="flecha izquierda" src={leftArrow}/>IR A MENTORIA DE TALENTO
                    </Link>
                </div>
                {Math.floor(optionArray.length / 9) > 0 && 
                    <div className="o-mentors-intern__paginator">
                        <button 
                            onClick={() => {setActiveIndex(activeIndex-1)}}
                            disabled={activeIndex === 0}
                            className="o-mentors-intern__paginator-button"
                        >
                            Atrás
                        </button>
                        {Array.from({ length: Math.floor(optionArray.length / 9) + 1 }, (_, index) =>
                            <button 
                                onClick={() => {setActiveIndex(index)}}
                                disabled={activeIndex===index}
                                className="o-mentors-intern__paginator-button"
                            >
                                {index + 1}
                            </button>
                        )}
                        <button 
                            onClick={() => {setActiveIndex(activeIndex+1)}}
                            disabled={activeIndex === Math.floor(optionArray.length / 9)}
                            className="o-mentors-intern__paginator-button"
                        >
                            Siguiente
                        </button>
                    </div>
                }
            </section>
            {isOpenModal && (
                <div className="m-number-steps__modal">
                    <div className="m-carousel-mentors__modal-content">
                        <button className="m-carousel-mentors__modal-close" onClick={() => setIsOpenModal(false)}>
                            <img className="m-carousel-mentors__modal-close-img" src={equisCirculo} alt="icono x"/>
                        </button>
                        <img src={detailCardInfo?.imagenPerfil.file.url} className="m-carousel-mentors__modal-img"/>
                        <div className="m-carousel-mentors__modal-container">
                            <div className="m-carousel-mentors__modal-name">
                                <span className="m-carousel-mentors__name">{detailCardInfo?.tituloBanner}</span>
                                <span className="m-carousel-mentors__location">{`Mentor - ${detailCardInfo?.tituloDescripcion}`}</span>
                            </div>
                            {documentToReactComponents(detailCardInfo?.descripcion.json)}
                            <div className="m-carousel-mentors__skills">
                                <span className="m-carousel-mentors__skills-title">Skills:</span>
                                <span className="m-carousel-mentors__skills-description">{detailCardInfo?.tipoTitulo}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
        
    );
};

export default MentorsIntern;